module.exports = __webpack_public_path__ + "img/hr-V-R-3-load-connect-shadow.5a748928.png";